module.exports = __webpack_public_path__ + "img/informacao-arquivo.bcbce332.svg";